import React, { Component } from "react";
import { connect } from "react-redux";


class Alert extends Component {
    render() {
        return (
            <div className={`alert alert-${this.props.type} fade show text-center margin-bottom-1x margin-top-1x`}>
                <i className="icon-layers"></i>&nbsp;&nbsp;<strong>{(this.props.title ? `${this.props.title}: ` : '')}</strong>{this.props.msg}
                {this.props.children}
            </div>);
  }
}

export default connect(null, null)(Alert);
